/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GreenhouseAccountCto } from '../../models/greenhouse-account-cto';

export interface GetActiveGreenhouseAccountsAsync$Plain$Params {
}

export function getActiveGreenhouseAccountsAsync$Plain(http: HttpClient, rootUrl: string, params?: GetActiveGreenhouseAccountsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GreenhouseAccountCto>>> {
  const rb = new RequestBuilder(rootUrl, getActiveGreenhouseAccountsAsync$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GreenhouseAccountCto>>;
    })
  );
}

getActiveGreenhouseAccountsAsync$Plain.PATH = '/integrations/greenhouse/companies';
